module.exports = __webpack_public_path__ + "img/warn.7d9e2c00.svg";